import * as Factory from 'factory.ts'

import { type SsoProvider } from '../../models'

export const SsoProviderMock = Factory.Sync.makeFactory<SsoProvider>({
  provider: 'azure-oidc',
  name: 'Azure',
})
